import { Badge } from '@amzn/awsui-components-core';
import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { workflowStateDisplayNames } from '../utils/DisplayNames';

class WorkflowStateBadge extends React.Component<{ state: WorkflowState }> {
  private static displayConfig = new Map<
    WorkflowState,
    { color: 'blue' | 'grey' | 'green' | 'red'; displayName: string }
    // @ts-expect-error TS2769 - strict migration
  >([
    [
      WorkflowState.PENDING_REVIEW,
      { color: 'grey', displayName: workflowStateDisplayNames.get(WorkflowState.PENDING_REVIEW) },
    ],
    [
      WorkflowState.IN_REVIEW,
      { color: 'blue', displayName: workflowStateDisplayNames.get(WorkflowState.IN_REVIEW) },
    ],
    [
      WorkflowState.REVIEWED,
      { color: 'blue', displayName: workflowStateDisplayNames.get(WorkflowState.REVIEWED) },
    ],
    [
      WorkflowState.MODIFIED,
      { color: 'grey', displayName: workflowStateDisplayNames.get(WorkflowState.MODIFIED) },
    ],
    [
      WorkflowState.NEW,
      { color: 'grey', displayName: workflowStateDisplayNames.get(WorkflowState.NEW) },
    ],
    [
      WorkflowState.UNMODIFIED,
      { color: 'green', displayName: workflowStateDisplayNames.get(WorkflowState.UNMODIFIED) },
    ],
    [
      WorkflowState.REJECTED,
      { color: 'red', displayName: workflowStateDisplayNames.get(WorkflowState.REJECTED) },
    ],
    [
      WorkflowState.PUBLISHED,
      { color: 'green', displayName: workflowStateDisplayNames.get(WorkflowState.PUBLISHED) },
    ],
    [
      WorkflowState.FINALIZING,
      { color: 'blue', displayName: workflowStateDisplayNames.get(WorkflowState.FINALIZING) },
    ],
    [
      WorkflowState.FINALIZED,
      { color: 'green', displayName: workflowStateDisplayNames.get(WorkflowState.FINALIZED) },
    ],
    [
      WorkflowState.UNPUBLISHED,
      { color: 'red', displayName: workflowStateDisplayNames.get(WorkflowState.UNPUBLISHED) },
    ],
    [
      WorkflowState.DISTRIBUTED,
      { color: 'green', displayName: workflowStateDisplayNames.get(WorkflowState.DISTRIBUTED) },
    ],
    [
      WorkflowState.REVOKED,
      { color: 'red', displayName: workflowStateDisplayNames.get(WorkflowState.REVOKED) },
    ],
    [
      WorkflowState.QUALITY_CHECK,
      { color: 'blue', displayName: workflowStateDisplayNames.get(WorkflowState.QUALITY_CHECK) },
    ],
    [
      WorkflowState.PUBLISHER_REVIEW,
      { color: 'blue', displayName: workflowStateDisplayNames.get(WorkflowState.PUBLISHER_REVIEW) },
    ],
    [
      WorkflowState.PREAUTHORING_REVIEW,
      {
        color: 'grey',
        displayName: workflowStateDisplayNames.get(WorkflowState.PREAUTHORING_REVIEW),
      },
    ],
    [
      WorkflowState.PREAUTHORING_REJECTED,
      {
        color: 'grey',
        displayName: workflowStateDisplayNames.get(WorkflowState.PREAUTHORING_REJECTED),
      },
    ],
    [
      WorkflowState.PREAUTHORING_MORE_INFO_NEEDED,
      {
        color: 'grey',
        displayName: workflowStateDisplayNames.get(WorkflowState.PREAUTHORING_MORE_INFO_NEEDED),
      },
    ],
  ]);
  render() {
    const { state } = this.props;

    if (!state) {
      return null;
    }

    const config = WorkflowStateBadge.displayConfig.get(state) || {
      color: 'grey',
      displayName: 'Unknown',
    };
    return <Badge color={config.color} children={config.displayName} />;
  }
}

export default WorkflowStateBadge;
